

import { GenerateTripAccommodations } from "@/app/constants/configuration/generateTripAccommodations"
import { GeneratedTripCountrySourceType } from "@/app/constants/configuration/generatedTripCountrySourceType"
import { TripPartEuropeMode } from "@/app/constants/configuration/tripPartEuropeMode"
import { TripSanitarityMode } from "@/app/constants/configuration/tripSanitarityMode"
import { TripSanitarityCostMode } from "@/app/constants/configuration/tripSanitarityCostMode"
import { TripHomelandAllowanceDurationSource } from "@/app/constants/configuration/tripHomelandAllowanceDurationSource"
import { DaysType } from "@/app/constants/configuration/daysType"
import { TripMonthType } from "@/app/constants/configuration/tripMonthType"
import { TripPartGenerationMode } from "@/app/constants/configuration/tripPartGenerationMode"
import { CountrySource } from "@/app/constants/configuration/countrySource"
import type { BusinessTripSettingsState as State } from './types'

export const defaultState: State = {
  tripAccomodationCountrySource: CountrySource.Mix,
  tripSetMultipleDestinationCountries: false,
  tripAddAccomodationOnlyForValidPolishNightRest: false,
  addAccommodationForFerryTrain: false,
  generateTripAccommodations: TripPartGenerationMode.Mix,
  skipRegularRestForAccommodations: false,
  generateTripAccommodationsTime: '',
  tripPartType: TripPartGenerationMode.Mix,
  tripPartForeignCountryMode: TripPartGenerationMode.Mix,
  useExchangeRatesTableB: false,
  isBeginEndGpsOptionEnabled: false,
  showAmountsInCurrenciesSummaryOnDetailedTripDocument: false,
  showAmountToConfirmInEurForDetaildTripPrint: false,
  showConfirmedAmountsOnBusinessTrip: false,
  // grouped
  tripCurrencyTableDaysType: DaysType.Day1,
  tripCurrencyTableDaysCount: 0,
  // missing month
  tripCalculationDateDaysType: DaysType.DelegationEnd,
  tripCalculationDateDaysCount: 0,
  tripCalculationDateMonth: TripMonthType.FromCurrentMonth,
  homelandAllowanceDurationSource: TripHomelandAllowanceDurationSource.AllParts,
  tripNumberPattern: '',
  // Ustawa z dnia
  tripPartEuropeModeStartFrom: null, //new Date().getTime(),
  tripPartEuropeMode: TripPartEuropeMode.Group,
  tripAccommodationInvoiceGeneration: false,
  tripSanitarityMode: TripSanitarityMode.Off,
  tripSanitarityCostMode: TripSanitarityCostMode.EuropeMode,
  // Konfiguracja państwa
  priorityCountries: [],
  // Automatyczne delegacje zbiorcze
  generatedTripCountrySource: GeneratedTripCountrySourceType.FromGps,
  includeTmsLoads: false,
  extendCountryChangesSearch: false,
  extendedBorderSearchRange: false,
  isGeneratedTripTransit: false,
  startTripsFromDriving: false,
  minDrivingMinutesForStartOnDriving: 0,
  minDrivingMinutesForEndOnDriving: 0,
  skipManualEntrisOnAutoTrips: false,
  maxManualEntryOnAutoTrips: 0,
  skipNoDataOnAutoTrips: false,
  maxNoDataOnAutoTrips: 0,

  //
  tripCurrencyTableMonth: 0
}

type CommonControlConfig<State> = {
    type: 'options_select' | 'options_country' | 'options_radio' | 'input_date' | 'boolean_checkbox' | 'input_text' | 'input_number'
    readOnly?: boolean
    suffix?: string
    getValue: (state: State) => string
    setValue: (value: string) => void
    //React.SetStateAction<State>
}
type Option = {
    key?: string | number
    value: string
    label: string
}

type OptionsControlConfig<State> = CommonControlConfig<State> & {
    type: 'options_select' | 'options_country' | 'options_radio'
    options: Option[]
}

type InputControlConfig<State> = CommonControlConfig<State> & {
    type: 'input_date' | 'input_text' | 'input_number'
}

type BooleanControlConfig<State> = CommonControlConfig<State> & {
    type: 'boolean_checkbox'
}

type ControlConfig<T> = OptionsControlConfig<T> | InputControlConfig<T> | BooleanControlConfig<T>

type FieldsetConfig<T> = {
    key: string | number,
    title?: string
    titleTranslationKey?: string
    label?: string
    labelTranslationKey?: string
    helper?: string
    helperTranslationKey?: string
    tooltip?: string
    tooltipTranslationKey?: string
    control: ControlConfig<T>
    additionalControl?: ControlConfig<T>
    additionalControlJoin?: string
}

type SectionConfig<T> = {
    key: string | number,
    title?: string
    titleTranslationKey?: string
    fieldsets: FieldsetConfig<T>[]
}

export const GENERATE_TRIP_ACCOMODATION_OPTIONS: GenerateTripAccommodations[] = [
    GenerateTripAccommodations.False,
    GenerateTripAccommodations.True,
    GenerateTripAccommodations.OnlyForValidRests,
    GenerateTripAccommodations.OnlyPolish,
]

export const GENERATED_TRIP_COUNTRY_SOURCE_TYPES: GeneratedTripCountrySourceType[] = [
    GeneratedTripCountrySourceType.FromTacho,
    GeneratedTripCountrySourceType.FromGps,
    GeneratedTripCountrySourceType.MixMode,
]

export const EUROPE_MODES: TripPartEuropeMode[] = [
    TripPartEuropeMode.Group,
    TripPartEuropeMode.Mix,
    TripPartEuropeMode.Skip,
]

export const SANITARITY_MODES: TripSanitarityMode[] = [
    TripSanitarityMode.Off,
    TripSanitarityMode.CalculateByTripParts,
    TripSanitarityMode.CalculateByDays,
]

export const SANITARITY_COST_MODES: TripSanitarityCostMode[] = [
    TripSanitarityCostMode.EuropeMode,
    TripSanitarityCostMode.CountryMode,
]

export const HOMELAND_ALLOWANCE_DURATION_SOURCES: TripHomelandAllowanceDurationSource[] = [
    TripHomelandAllowanceDurationSource.HomelandPart,
    TripHomelandAllowanceDurationSource.AllParts,
]

export const CALCULATION_DAY_TYPES: DaysType[] = [
    DaysType.Day1,
    DaysType.Day2,
    DaysType.Day3,
    DaysType.Day4,
    DaysType.Day5,
    DaysType.Day6,
    DaysType.Day7,
    DaysType.Day8,
    DaysType.Day9,
    DaysType.Day10,
    DaysType.Day11,
    DaysType.Day12,
    DaysType.Day13,
    DaysType.Day14,
    DaysType.Day15,
    DaysType.Day16,
    DaysType.Day17,
    DaysType.Day18,
    DaysType.Day19,
    DaysType.Day20,
    DaysType.Day21,
    DaysType.Day22,
    DaysType.Day23,
    DaysType.Day24,
    DaysType.Day25,
    DaysType.Day26,
    DaysType.Day27,
    DaysType.Day28,
    DaysType.Day29,
    DaysType.Day30,
    DaysType.LastDay,
    DaysType.DelegationEnd,
    DaysType.CurrentDate,
]

export const TRIP_MONTH_TYPES: TripMonthType[] = [
    TripMonthType.FromCurrentMonth,
    TripMonthType.FromTripStart,
    TripMonthType.FromTripEnd,
]

export const shouldDisplayTripMonthTypeField = (tripCalculationDateDaysType: DaysType) => {
    return !(
        tripCalculationDateDaysType ==
        DaysType.DelegationEnd ||
        tripCalculationDateDaysType ==
        DaysType.CurrentDate ||
        tripCalculationDateDaysType ==
        DaysType.DelegationCalculationDate
    )
}

export const shouldDisplayTripCurrencyTableDaysTypeAdditionalField = (tripCurrencyTableDaysType: DaysType) => {
    return (
        tripCurrencyTableDaysType == DaysType.LastDay ||
        tripCurrencyTableDaysType ==
        DaysType.CurrentDate ||
        tripCurrencyTableDaysType ==
        DaysType.DelegationEnd ||
        tripCurrencyTableDaysType ==
        DaysType.DelegationCalculationDate
    )
}

export const DAY_TYPES: DaysType[] = [
    DaysType.Day1,
    DaysType.Day2,
    DaysType.Day3,
    DaysType.Day4,
    DaysType.Day5,
    DaysType.Day6,
    DaysType.Day7,
    DaysType.Day8,
    DaysType.Day9,
    DaysType.Day10,
    DaysType.Day11,
    DaysType.Day12,
    DaysType.Day13,
    DaysType.Day14,
    DaysType.Day15,
    DaysType.Day16,
    DaysType.Day17,
    DaysType.Day18,
    DaysType.Day19,
    DaysType.Day20,
    DaysType.Day21,
    DaysType.Day22,
    DaysType.Day23,
    DaysType.Day24,
    DaysType.Day25,
    DaysType.Day26,
    DaysType.Day27,
    DaysType.Day28,
    DaysType.Day29,
    DaysType.Day30,
    DaysType.LastDay,
    DaysType.DelegationEnd,
    DaysType.DelegationCalculationDate,
    DaysType.CurrentDate,
]

export const GENERATION_MODES: TripPartGenerationMode[] = [
  TripPartGenerationMode.Group,
  TripPartGenerationMode.Single,
  TripPartGenerationMode.Mix,
//   TripPartGenerationMode.Skip,
]

export const COUNTRY_SOURCES: CountrySource[] = [
  CountrySource.Delegation,
  CountrySource.Card,
  CountrySource.Mix,
  CountrySource.DestinationCountry,
]
